import React from 'react';
import styled from 'styled-components';
import { LinkButton } from '../components/form';
import { PrimaryFont } from '../components/styles';
import { INTERNAL_LINKS } from '../utils/links';
import { THEME_COLORS } from '../utils/theme';

const CenterContainer = styled.div`
  width: 100vw;
  height: 90vh;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  color: ${THEME_COLORS.text};
`;

const Title = styled(PrimaryFont)`
  display: block;
  color: ${THEME_COLORS.brandPink};
  font-size: 3rem;
  margin-bottom: 20px;
`;

export const Page404: React.FC = () => {
  return (
    <CenterContainer>
      <Title>404</Title>
      <PrimaryFont>Oops! We couldn't find this page, much like that one last puzzle piece.</PrimaryFont>
      <LinkButton href={INTERNAL_LINKS.HOME} style={{ marginTop: 50 }}>
        Back Home
      </LinkButton>
    </CenterContainer>
  );
};
